import React from "react";
import { useParams } from "react-router-dom";

import FlagsPage from "cortex/ui/src/fleet/view/flags/FlagsPage";
import { useAppDispatch, useAppSelector } from "cortex/ui/src/hooks";
import { createPromiseApiAction } from "cortex/ui/src/redux-store/api-sagas";
import { getAuthUser } from "cortex/ui/src/redux-store/auth/selectors";
import { EDIT_DEVICE_FLAGS } from "cortex/ui/src/redux-store/devices/actions";
import { networksSelector } from "cortex/ui/src/redux-store/networks/selectors";
import { currentDeviceSelector } from "cortex/ui/src/redux-store/ui-state/current-device/selectors";
import { isReadonly } from "cortex/ui/src/redux-store/users/selectors";
import { storesReady } from "cortex/ui/src/redux-store/utils";
import { FetchController } from "cortex/ui/src/ui/fetch";

export function DeviceFlagsContent() {
  const dispatch = useAppDispatch();
  const device = useAppSelector(currentDeviceSelector);
  const storesLoaded = useAppSelector((state) =>
    storesReady((state as any).global.networks),
  );
  const networks = useAppSelector(networksSelector);
  const user = useAppSelector(getAuthUser);
  const readonly = isReadonly(user);
  const networkId = device?.network_id;
  const network = networkId ? networks[networkId] : undefined;
  const networkUserFlags = network?.user_flags || [];

  return (
    <FlagsPage
      model={device}
      networkUserFlags={networkUserFlags}
      readonly={readonly}
      storesLoaded={storesLoaded}
      type="device"
      updateFlags={(serviceArgs: {
        id: number | string;
        flags: Record<string, string>;
      }) => {
        return createPromiseApiAction(dispatch, EDIT_DEVICE_FLAGS, [
          serviceArgs.id,
          serviceArgs.flags,
        ]);
      }}
    />
  );
}

export default function DeviceFlagsPage() {
  const { deviceId } = useParams<{ deviceId: string }>();

  return (
    <FetchController.Device deviceId={deviceId}>
      <DeviceFlagsContent />
    </FetchController.Device>
  );
}
